import * as Sentry from '@sentry/browser';

import { finleyAssert } from '@finley-technologies/common';

export const parseAssignmentSummaryPreview = (
  assignmentSummaryPreview: string,
  isInitialPreview: boolean,
) => {
  try {
    // @jendevelops TODO: validate data coming from backend

    const parsedAssignmentSummaryPreview = JSON.parse(assignmentSummaryPreview);

    if (isInitialPreview) {
      finleyAssert(
        parsedAssignmentSummaryPreview,
        `Expected initial summary preview to exist`,
      );
    }

    return parsedAssignmentSummaryPreview;
  } catch (err) {
    // @jendevelops TODO: handle parsing error
    Sentry.captureException(JSON.stringify(err));
    throw err;
  }
};
